var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h3',[_vm._v("送付内容")]),_c('FormWrapper',{attrs:{"schemaName":"LetterPackDetail","disabled":_vm.disabled},model:{value:(_vm.model.letterPackDetail),callback:function ($$v) {_vm.$set(_vm.model, "letterPackDetail", $$v)},expression:"model.letterPackDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }